const colors = {
  "anthra":             "#535454",
  "bordeaux":           "#a51f34",
  "braun":              "#694d1f",
  "creme/beige":        "#ecdfcb",
  "gelb":               "#ffdd0f",
  "grau":               "#7d8081",
  "taupe/greige":       "#a99d90",
  "grün":               "#93c23b",
  "klar":               "#f6f6f6",
  "lila / violett":     "#a73f90",
  "orange":             "#f39553",
  "pink":               "#e82d89",
  "rosa":               "#f79ca7",
  "rot":                "#d20019",
  "schwarz":            "#000000",
  "silber":             "#c0c0c0",
  "weiß":               "#ffffff",
  "blau":               "#036ad5",
  "bronze":             "#b1701b",
  "creme/greige":       "#ffffff",
  "gold":               "#d4af37",
  "naturweiß/offwhite": "#edece5",
}

export default colors


// WEBPACK FOOTER //
// ./src/theme/base/style/colors.js